import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { logErrorAndRunFail, paramCheckErrno } from '../../utils';
import { ApiErrno, errnoCategory1, errnoCategory2, errorType } from 'src/shared/errno';

export interface NavigateToMiniProgramOptions
  extends Partial<GeneralInvokeOption> {
  appId: string;
  capsuleShow?:boolean;
  path?: string;
  params?: string;
  invalidParamObj?: any;
}

export function navigateToMiniProgram(option: NavigateToMiniProgramOptions) {
  // 判断必填参数appId是否传入
  if (option.appId === undefined) {
    return logErrorAndRunFail(
      APINames.Native.NAVIGATE_TO_MINI_PROGRAM,
      option,
      `parameter error: parameter.appId is necessary, please check input param.`,
      ApiErrno.Errno(errnoCategory1.COMMON, errnoCategory2.COMMON, errorType.MISSING_PARAM)
    );
  }
  if (
    paramCheckErrno(APINames.Native.NAVIGATE_TO_MINI_PROGRAM, option, {
      appId: '',
      capsuleShow: true,
      path: '',
      params: ''
    })
  ) {
    if (!option.path && option.params) {
      return logErrorAndRunFail(
        APINames.Native.NAVIGATE_TO_MINI_PROGRAM,
        option,
        'parameter error: there is params but no path.',
        ApiErrno.Errno(errnoCategory1.COMMON, errnoCategory2.COMMON, errorType.MISSING_PARAM)
      );
    }
    return MacleJSBridge.beforeInvoke(
      APINames.Native.NAVIGATE_TO_MINI_PROGRAM,
      option
    );
  }
  return option.invalidParamObj;
}
